// Full list of Calculator.net calculators organized by 4 categories
// implemented=true means we have a working page, false shows "Coming soon"

export const CATEGORIES = [
  {
    id: 'financial',
    name: 'Financial Calculators',
    color: 'blue',
    icon: 'DollarSign',
    description: 'Loans, mortgages, investments, taxes, and more',
    tools: [
      { slug: 'mortgage', name: 'Mortgage Calculator', implemented: true },
      { slug: 'loan', name: 'Loan Calculator', implemented: true },
      { slug: 'auto-loan', name: 'Auto Loan Calculator', implemented: true },
      { slug: 'interest', name: 'Interest Calculator', implemented: true },
      { slug: 'payment', name: 'Payment Calculator', implemented: true },
      { slug: 'retirement', name: 'Retirement Calculator', implemented: true },
      { slug: 'amortization', name: 'Amortization Calculator', implemented: true },
      { slug: 'investment', name: 'Investment Calculator', implemented: true },
      { slug: 'inflation', name: 'Inflation Calculator', implemented: true },
      { slug: 'finance', name: 'Finance Calculator', implemented: true },
      { slug: 'income-tax', name: 'Income Tax Calculator', implemented: true },
      { slug: 'compound-interest', name: 'Compound Interest Calculator', implemented: true },
      { slug: 'salary', name: 'Salary Calculator', implemented: true },
      { slug: 'interest-rate', name: 'Interest Rate Calculator', implemented: true },
      { slug: 'sales-tax', name: 'Sales Tax Calculator', implemented: true },
      { slug: 'currency', name: 'Currency Calculator', implemented: true },
      { slug: 'house-affordability', name: 'House Affordability Calculator', implemented: true },
      { slug: 'rent', name: 'Rent Calculator', implemented: true },
      { slug: 'debt-to-income', name: 'Debt-to-Income Ratio Calculator', implemented: true },
      { slug: 'real-estate', name: 'Real Estate Calculator', implemented: true },
      { slug: 'boat-loan', name: 'Boat Loan Calculator', implemented: true },
      { slug: 'refinance', name: 'Refinance Calculator', implemented: true },
      { slug: 'rental-property', name: 'Rental Property Calculator', implemented: true },
      { slug: 'apr', name: 'APR Calculator', implemented: true },
      { slug: 'roi', name: 'ROI Calculator', implemented: true },
      { slug: 'average-return', name: 'Average Return Calculator', implemented: true },
      { slug: 'irr', name: 'IRR Calculator', implemented: true },
      { slug: 'bond', name: 'Bond Calculator', implemented: true },
      { slug: 'simple-interest', name: 'Simple Interest Calculator', implemented: true },
      { slug: 'present-value', name: 'Present Value Calculator', implemented: true },
      { slug: 'future-value', name: 'Future Value Calculator', implemented: true },
      { slug: 'cd', name: 'CD Calculator', implemented: true },
      { slug: 'savings', name: 'Savings Calculator', implemented: true },
      { slug: 'fha-loan', name: 'FHA Loan Calculator', implemented: true },
      { slug: 'va-mortgage', name: 'VA Mortgage Calculator', implemented: true },
      { slug: 'mortgage-payoff', name: 'Mortgage Payoff Calculator', implemented: true },
      { slug: 'mortgage-amortization', name: 'Mortgage Amortization Calculator', implemented: true },
      { slug: 'heloc', name: 'HELOC Calculator', implemented: true },
      { slug: 'home-equity-loan', name: 'Home Equity Loan Calculator', implemented: true },
      { slug: 'canadian-mortgage', name: 'Canadian Mortgage Calculator', implemented: true },
      { slug: 'uk-mortgage', name: 'UK Mortgage Calculator', implemented: true },
      { slug: 'down-payment', name: 'Down Payment Calculator', implemented: true },
      { slug: 'rent-vs-buy', name: 'Rent vs. Buy Calculator', implemented: true },
      { slug: '401k', name: '401K Calculator', implemented: true },
      { slug: 'roth-ira', name: 'Roth IRA Calculator', implemented: true },
      { slug: 'ira', name: 'IRA Calculator', implemented: true },
      { slug: 'rmd', name: 'RMD Calculator', implemented: true },
      { slug: 'annuity', name: 'Annuity Calculator', implemented: true },
      { slug: 'annuity-payout', name: 'Annuity Payout Calculator', implemented: true },
      { slug: 'mutual-fund', name: 'Mutual Fund Calculator', implemented: true },
      { slug: 'cash-back', name: 'Cash Back or Low Interest Calculator', implemented: true },
      { slug: 'social-security', name: 'Social Security Calculator', implemented: true },
      { slug: 'pension', name: 'Pension Calculator', implemented: true },
      { slug: 'estate-tax', name: 'Estate Tax Calculator', implemented: true },
      { slug: 'take-home-pay', name: 'Take-Home-Paycheck Calculator', implemented: true },
      { slug: 'marriage-tax', name: 'Marriage Tax Calculator', implemented: true },
      { slug: 'depreciation', name: 'Depreciation Calculator', implemented: true },
      { slug: 'margin', name: 'Margin Calculator', implemented: true },
      { slug: 'discount', name: 'Discount Calculator', implemented: true },
      { slug: 'percent-off', name: 'Percent Off Calculator', implemented: true },
      { slug: 'business-loan', name: 'Business Loan Calculator', implemented: true },
      { slug: 'personal-loan', name: 'Personal Loan Calculator', implemented: true },
      { slug: 'lease', name: 'Lease Calculator', implemented: true },
      { slug: 'auto-lease', name: 'Auto Lease Calculator', implemented: true },
      { slug: 'payback-period', name: 'Payback Period Calculator', implemented: true },
      { slug: 'budget', name: 'Budget Calculator', implemented: true },
      { slug: 'credit-card', name: 'Credit Card Calculator', implemented: true },
      { slug: 'credit-cards-payoff', name: 'Credit Cards Payoff Calculator', implemented: true },
      { slug: 'debt-payoff', name: 'Debt Payoff Calculator', implemented: true },
      { slug: 'debt-consolidation', name: 'Debt Consolidation Calculator', implemented: true },
      { slug: 'repayment', name: 'Repayment Calculator', implemented: true },
      { slug: 'student-loan', name: 'Student Loan Calculator', implemented: true },
      { slug: 'college-cost', name: 'College Cost Calculator', implemented: true },
      { slug: 'vat', name: 'VAT Calculator', implemented: true },
      { slug: 'commission', name: 'Commission Calculator', implemented: true }
    ]
  },
  {
    id: 'fitness',
    name: 'Fitness & Health Calculators',
    color: 'green',
    icon: 'HeartPulse',
    description: 'BMI, body fat, calorie, pregnancy, and pace',
    tools: [
      { slug: 'bmi', name: 'BMI Calculator', implemented: true },
      { slug: 'anorexic-bmi', name: 'Anorexic BMI Calculator', implemented: true },
      { slug: 'army-body-fat', name: 'Army Body Fat Calculator', implemented: true },
      { slug: 'bac', name: 'Blood Alcohol Concentration (BAC) Calculator', implemented: true },
      { slug: 'body-type', name: 'Body Type Calculator', implemented: true },
      { slug: 'carbohydrate', name: 'Carbohydrate Calculator', implemented: true },
      { slug: 'fat-intake', name: 'Fat Intake Calculator', implemented: true },
      { slug: 'healthy-weight', name: 'Healthy Weight Calculator', implemented: true },
      { slug: 'overweight', name: 'Overweight Calculator', implemented: true },
      { slug: 'due-date', name: 'Pregnancy Due Date Calculator', implemented: true },
      { slug: 'conception', name: 'Conception Calculator', implemented: true },
      { slug: 'pregnancy-conception', name: 'Pregnancy Conception Calculator', implemented: true },
      { slug: 'pregnancy-weight-gain', name: 'Pregnancy Weight Gain Calculator', implemented: true },
      { slug: 'gfr', name: 'GFR Calculator', implemented: true },
      { slug: 'calorie', name: 'Calorie Calculator', implemented: true },
      { slug: 'body-fat', name: 'Body Fat Calculator', implemented: true },
      { slug: 'bmr', name: 'BMR Calculator', implemented: true },
      { slug: 'ideal-weight', name: 'Ideal Weight Calculator', implemented: true },
      { slug: 'pace', name: 'Pace Calculator', implemented: true },
      { slug: 'pregnancy', name: 'Pregnancy Calculator', implemented: true },
      { slug: 'macro', name: 'Macro Calculator', implemented: true },
      { slug: 'macronutrient', name: 'Macronutrient Calculator', implemented: true },
      { slug: 'protein', name: 'Protein Calculator', implemented: true },
      { slug: 'tdee', name: 'TDEE Calculator', implemented: true },
      { slug: 'calories-burned', name: 'Calories Burned Calculator', implemented: true },
      { slug: 'one-rep-max', name: 'One Rep Max Calculator', implemented: true },
      { slug: 'target-heart-rate', name: 'Target Heart Rate Calculator', implemented: true },
      { slug: 'body-surface-area', name: 'Body Surface Area Calculator', implemented: true },
      { slug: 'lean-body-mass', name: 'Lean Body Mass Calculator', implemented: true },
      { slug: 'calories-to-lose', name: 'Calories to Lose Weight Calculator', implemented: false },
      { slug: 'period', name: 'Period Calculator', implemented: true },
      { slug: 'ovulation', name: 'Ovulation Calculator', implemented: true },
      { slug: 'estimated-energy', name: 'Estimated Energy Requirement Calculator', implemented: true },
      { slug: 'bra-size', name: 'Bra Size Calculator', implemented: true }
    ]
  },
  {
    id: 'math',
    name: 'Math Calculators',
    color: 'purple',
    icon: 'Sigma',
    description: 'Scientific, fractions, statistics, and geometry',
    tools: [
      { slug: 'scientific', name: 'Scientific Calculator', implemented: true },
      { slug: 'graph', name: 'Graph Tool', implemented: true },
      { slug: 'fraction', name: 'Fraction Calculator', implemented: true },
      { slug: 'percentage', name: 'Percentage Calculator', implemented: true },
      { slug: 'random-number', name: 'Random Number Generator', implemented: true },
      { slug: 'triangle', name: 'Triangle Calculator', implemented: true },
      { slug: 'standard-deviation', name: 'Standard Deviation Calculator', implemented: true },
      { slug: 'statistics', name: 'Statistics Calculator', implemented: true },
      { slug: 'number-sequence', name: 'Number Sequence Calculator', implemented: true },
      { slug: 'root', name: 'Root Calculator', implemented: true },
      { slug: 'exponent', name: 'Exponent Calculator', implemented: true },
      { slug: 'logarithm', name: 'Logarithm Calculator', implemented: true },
      { slug: 'modulo', name: 'Modulo Calculator', implemented: true },
      { slug: 'prime-factorization', name: 'Prime Factorization Calculator', implemented: true },
      { slug: 'ratio', name: 'Ratio Calculator', implemented: true },
      { slug: 'quadratic', name: 'Quadratic Formula Calculator', implemented: true },
      { slug: 'slope', name: 'Slope Calculator', implemented: true },
      { slug: 'area', name: 'Area Calculator', implemented: true },
      { slug: 'volume', name: 'Volume Calculator', implemented: true },
      { slug: 'surface-area', name: 'Surface Area Calculator', implemented: true },
      { slug: 'circle', name: 'Circle Calculator', implemented: true },
      { slug: 'right-triangle', name: 'Right Triangle Calculator', implemented: true },
      { slug: 'pythagorean', name: 'Pythagorean Theorem Calculator', implemented: true },
      { slug: 'distance', name: 'Distance Calculator', implemented: true },
      { slug: 'binary', name: 'Binary Calculator', implemented: true },
      { slug: 'hex', name: 'Hex Calculator', implemented: true },
      { slug: 'matrix', name: 'Matrix Calculator', implemented: true },
      { slug: 'gcf', name: 'Greatest Common Factor Calculator', implemented: true },
      { slug: 'common-factor', name: 'Common Factor Calculator', implemented: true },
      { slug: 'lcm', name: 'Least Common Multiple Calculator', implemented: true },
      { slug: 'factor', name: 'Factor Calculator', implemented: true },
      { slug: 'rounding', name: 'Rounding Calculator', implemented: true },
      { slug: 'big-number', name: 'Big Number Calculator', implemented: true },
      { slug: 'half-life', name: 'Half-Life Calculator', implemented: true },
      { slug: 'sample-size', name: 'Sample Size Calculator', implemented: true },
      { slug: 'probability', name: 'Probability Calculator', implemented: true },
      { slug: 'permutation', name: 'Permutation and Combination Calculator', implemented: true },
      { slug: 'confidence-interval', name: 'Confidence Interval Calculator', implemented: true },
      { slug: 'mean-median', name: 'Mean, Median, Mode, Range Calculator', implemented: true },
      { slug: 'z-score', name: 'Z-Score Calculator', implemented: true },
      { slug: 'p-value', name: 'P-Value Calculator', implemented: true },
      { slug: 'long-division', name: 'Long Division Calculator', implemented: true },
      { slug: 'dice-roller', name: 'Dice Roller', implemented: true },

      // New top-level tools
      { slug: 'basic', name: 'Basic Calculator', implemented: true },
      { slug: 'scientific-notation', name: 'Scientific Notation Calculator', implemented: true },
      { slug: 'percent-error', name: 'Percent Error Calculator', implemented: true },
      { slug: 'average', name: 'Average Calculator', implemented: true },

      // Fraction sub-calculators
      { slug: 'fraction-simplify', name: 'Simplify Fractions Calculator', implemented: true },
      { slug: 'decimal-to-fraction', name: 'Decimal to Fraction Calculator', implemented: true },
      { slug: 'fraction-to-decimal', name: 'Fraction to Decimal Calculator', implemented: true },
      { slug: 'mixed-number', name: 'Mixed Numbers Calculator', implemented: true },
      { slug: 'big-number-fraction', name: 'Big Number Fraction Calculator', implemented: true },

    ]
  },
  {
    id: 'other',
    name: 'Other Calculators',
    color: 'orange',
    icon: 'Wrench',
    description: 'Age, date, time, GPA, conversions, and utilities',
    tools: [
      { slug: 'age', name: 'Age Calculator', implemented: true },
      { slug: 'date', name: 'Date Calculator', implemented: true },
      { slug: 'time', name: 'Time Calculator', implemented: true },
      { slug: 'hours', name: 'Hours Calculator', implemented: true },
      { slug: 'gpa', name: 'GPA Calculator', implemented: true },
      { slug: 'grade', name: 'Grade Calculator', implemented: true },
      { slug: 'password', name: 'Password Generator', implemented: true },
      { slug: 'conversion', name: 'Conversion Calculator', implemented: true },
      { slug: 'love', name: 'Love Calculator', implemented: true },
      { slug: 'day-counter', name: 'Day Counter', implemented: true },
      { slug: 'gas-mileage', name: 'Gas Mileage Calculator', implemented: true },
      { slug: 'tire-size', name: 'Tire Size Calculator', implemented: true },
      { slug: 'concrete', name: 'Concrete Calculator', implemented: true },
      { slug: 'height', name: 'Height Calculator', implemented: true },
      { slug: 'roman-numeral', name: 'Roman Numeral Converter', implemented: true },
      { slug: 'time-zone', name: 'Time Zone Calculator', implemented: true },
      { slug: 'time-card', name: 'Time Card Calculator', implemented: true },
      { slug: 'time-duration', name: 'Time Duration Calculator', implemented: true },
      { slug: 'countdown', name: 'Countdown Timer', implemented: true },
      { slug: 'gravel', name: 'Gravel Calculator', implemented: true },
      { slug: 'stair', name: 'Stair Calculator', implemented: true },
      { slug: 'roofing', name: 'Roofing Calculator', implemented: true },
      { slug: 'wind-chill', name: 'Wind Chill Calculator', implemented: true },
      { slug: 'heat-index', name: 'Heat Index Calculator', implemented: true },
      { slug: 'dew-point', name: 'Dew Point Calculator', implemented: true },
      { slug: 'ring-size', name: 'Ring Size Calculator', implemented: true },
      { slug: 'shoe-size', name: 'Shoe Size Conversion', implemented: true },
      { slug: 'engine-horsepower', name: 'Engine Horsepower Calculator', implemented: true },
      { slug: 'horsepower', name: 'Horsepower Calculator', implemented: true },
      { slug: 'mulch', name: 'Mulch Calculator', implemented: true },
      { slug: 'square-footage', name: 'Square Footage Calculator', implemented: true },
      { slug: 'btu', name: 'BTU Calculator', implemented: true },
      { slug: 'ip-subnet', name: 'IP Subnet Calculator', implemented: true },
      { slug: 'bandwidth', name: 'Bandwidth Calculator', implemented: true },
      { slug: 'sleep', name: 'Sleep Calculator', implemented: true },
      { slug: 'fuel-cost', name: 'Fuel Cost Calculator', implemented: true },
      { slug: 'mileage', name: 'Mileage Reimbursement Calculator', implemented: true },
      { slug: 'wire-gauge', name: 'Wire Gauge Calculator', implemented: true },
      { slug: 'voltage-drop', name: 'Voltage Drop Calculator', implemented: true },
      { slug: 'ohms-law', name: 'Ohms Law Calculator', implemented: true },
      { slug: 'roman-numeral-date', name: 'Roman Numeral Date Converter', implemented: true },
      { slug: 'speed', name: 'Speed Calculator', implemented: true },
      { slug: 'density', name: 'Density Calculator', implemented: true },
      { slug: 'mass', name: 'Mass Calculator', implemented: true },
      { slug: 'weight-converter', name: 'Weight Converter', implemented: true },
      { slug: 'weight', name: 'Weight Calculator', implemented: true },
      { slug: 'molarity', name: 'Molarity Calculator', implemented: true },
      { slug: 'molecular-weight', name: 'Molecular Weight Calculator', implemented: true },
      { slug: 'tile', name: 'Tile Calculator', implemented: true },
      { slug: 'resistor', name: 'Resistor Calculator', implemented: true },
      { slug: 'base64', name: 'Base64 Encoder/Decoder', implemented: true },
      { slug: 'url-encode-decode', name: 'URL Encoder/Decoder', implemented: true },
      { slug: 'electricity', name: 'Electricity Calculator', implemented: true },
      { slug: 'gdp', name: 'GDP Calculator', implemented: true },
      { slug: 'tip', name: 'Tip Calculator', implemented: true },
      { slug: 'golf-handicap', name: 'Golf Handicap Calculator', implemented: true },
      { slug: 'day-of-week', name: 'Day of the Week Calculator', implemented: true }
    ]
  }
];

export const getAllTools = () => CATEGORIES.flatMap(c => c.tools.map(t => ({ ...t, category: c.id, categoryName: c.name })));
export const findTool = (slug) => getAllTools().find(t => t.slug === slug);
export const getCategory = (id) => CATEGORIES.find(c => c.id === id);
